<template>
  <DialogBase
    title="Thêm mới lớp học"
    :visible.sync="dialogVisible"
    size="sm"
    panel-icon="el-icon-school"
    panel-title="Thông tin lớp"
    panel-subtitle="Tạo lớp học mới trong khối"
    :confirm-loading="loadingButton"
    :confirm-disabled="!showSaveChange"
    confirm-text="Lưu"
    confirm-type="primary"
    cancel-text="Hủy"
    cancel-type=""
    cancel-icon=""
    confirm-icon=""
    @before-close="handleClose"
    @cancel="handleClose"
    @confirm="handleSave"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="formRules"
      label-position="top"
    >
      <!-- Chọn khối -->
      <el-form-item label="Chọn khối" prop="idGrade">
        <el-select
          v-model="dataForm.idGrade"
          placeholder="Chọn khối"
          class="sk-u-w-full"
        >
          <el-option
            v-for="item in gradeOfSchoolList"
            :key="item.id"
            :value="item.id"
            :label="item.gradeName"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="Tên lớp học" prop="className">
        <el-input
          :disabled="dataForm.idGrade === ''"
          v-model="dataForm.className"
          placeholder="Nhập tên lớp"
          @keyup.enter.native="handleSave"
        />
        <span v-if="customErrorMessages.newNameKt" class="sk-note sk-note--danger sk-u-mt-12">
          <i class="el-icon-warning-outline" />
          <span>{{ customErrorMessages.newNameKt }}</span>
        </span>
      </el-form-item>

      <el-form-item label="Mô tả" prop="classDescription" class="sk-u-mt-12">
        <el-input
          v-model="dataForm.classDescription"
          type="textarea"
          :rows="1"
          autosize
          placeholder="Nhập mô tả"
        />
      </el-form-item>
    </el-form>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import MaClassService from "@/services/MaClassService";
import { mapActions, mapState } from "vuex";
import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";

export default {
  components: { DialogBase },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataForm: {
        className: "",
        classDescription: "",
        idGrade: "",
      },
      classList: [],
      customErrorMessages: {
        newNameKt: "",
      },
      showSaveChange: false,
      newClassCreated: null,
      loadingButton: false,
      formRules: {
        className: [
          {
            validator: this.changeClassName,
            trigger: "change",
          },
        ],
        idGrade: [
          {
            required: true,
            message: "Khối không được để trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.$store.dispatch("gradeModule/fetchDataGradeOfSchoolList");
  },
  computed: {
    ...mapState("gradeModule", ["gradeOfSchoolList"]),
  },
  methods: {
    ...mapActions("gradeModule", ["fetchDataGradeOfSchoolList"]),
    ...mapActions("classStore", ["fetchDataClassOfGradeList"]),

    handleClose(done) {
      this.showSaveChange = false;
      this.customErrorMessages.newNameKt = "";
      this.dataForm.idGrade = "";
      this.dataForm.className = "";
      this.dataForm.classDescription = "";
      this.$emit("dialog-close");
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.resetFields();
        }
      });
      if (typeof done === "function") done();
    },

    async changeClassName(rule, value, callback) {
      await financeKidsV2Service
        .getClassInGrade(parseInt(this.dataForm.idGrade))
        .then((resp) => {
          resp.data && resp.data.data
            ? (this.classList = resp.data.data)
            : (this.classList = []);
        })
        .catch((err) => {
          console.log(err);
        });
      if (this.classList.length !== 0) {
        for (let i = 0; i < this.classList.length; i++) {
          if (!value) {
            this.customErrorMessages.newNameKt =
              "Giá trị không được để trống!";
            this.showSaveChange = false;
            break;
          } else if (
            value.toLowerCase().replace(/\s/g, "") ===
            this.classList[i].className.toLowerCase().replace(/\s/g, "")
          ) {
            this.customErrorMessages.newNameKt =
              "Tên lớp: " +
              this.classList[i].className +
              " đã tồn tại trong khối!";
            this.showSaveChange = false;
            break;
          } else {
            this.showSaveChange = true;
            this.customErrorMessages.newNameKt = "";
            callback();
          }
        }
      } else {
        this.showSaveChange = true;
        this.customErrorMessages.newNameKt = "";
        callback();
      }
    },

    async handleSave() {
      await this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          MaClassService.create(this.dataForm)
            .then((response) => {
              this.newClassCreated = response.data.data;
              this.$message({
                message: "Thêm mới lớp thành công",
                type: "success",
              });
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.handleClose();
              this.loadingButton = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";
</style>
